import {
  toCamelCase,
  useModalContext,
  WSButton,
  WSButtons,
  WSElementProps,
  WSForm,
  WSModal,
  WSRadioInputGroup,
  WSTextInput
} from "@wingspanhq/fe-component-library";
import React from "react";
import * as Yup from "yup";
import { WSErrorMessage } from "../../../../components/WSErrorMessage/WSErrorMessage";
import { useCreateCollaboratorSettingsAdditionalData } from "../../../../query/payments/mutations";
import { WSDataTypes } from "@wingspanhq/payments/dist/interfaces";
import { useListCollaboratorSettingsAdditionalData } from "../../../../query/payments/queries";

type Props = WSElementProps;

export const ADD_COLLABORATOR_CUSTOM_FIELD_MODAL =
  "ADD_COLLABORATOR_CUSTOM_FIELD_MODAL";

export const AddCustomFieldModal: React.FC<Props> = () => {
  const { closeModal } = useModalContext();

  const [
    createData,
    createDataMeta
  ] = useCreateCollaboratorSettingsAdditionalData();

  const qListAdditionalData = useListCollaboratorSettingsAdditionalData();

  return (
    <WSModal
      name={ADD_COLLABORATOR_CUSTOM_FIELD_MODAL}
      size="S"
      title="Create custom collaborator field"
    >
      <WSForm
        defaultValues={{
          name: "",
          fieldType: WSDataTypes.String,
          required: "yes"
        }}
        validationSchema={Yup.object().shape({
          name: Yup.string()
            .notOneOf(
              qListAdditionalData.data?.map(a => a.name) || [],
              "A custom field with this name already exists"
            )
            .required("Name is required"),
          fieldType: Yup.string(),
          required: Yup.string()
        })}
        onSubmit={async formData => {
          await createData(
            {
              name: formData.name,
              required: formData.required === "yes",
              type: formData.fieldType,
              key: toCamelCase(formData.name)
            },
            {
              onSuccess() {
                closeModal(ADD_COLLABORATOR_CUSTOM_FIELD_MODAL);
              }
            }
          );
        }}
      >
        <WSForm.Field
          mb="M"
          label="Field name"
          name="name"
          component={WSTextInput}
        />

        <WSForm.Field
          mb="L"
          label=" "
          name="required"
          component={WSRadioInputGroup}
          componentProps={{
            options: [
              {
                label: "Required",
                value: "yes"
              },
              {
                label: "Optional",
                value: "no"
              }
            ]
          }}
        />

        <WSForm.Field
          mb="M"
          label="Field type"
          name="fieldType"
          component={WSRadioInputGroup}
          componentProps={{
            options: [
              {
                label: "Text field",
                value: WSDataTypes.String
              },
              {
                label: "Checkbox",
                value: WSDataTypes.Boolean
              }
            ]
          }}
        />

        <WSErrorMessage
          mt="M"
          error={createDataMeta.error}
          contextKey="CreateCollaborator"
        />

        <WSButtons mt="XL" forceFullWidth>
          <WSForm.SubmitButton data-testid="submit">
            Create field
          </WSForm.SubmitButton>
          <WSButton.Tertiary
            onClick={() => closeModal(ADD_COLLABORATOR_CUSTOM_FIELD_MODAL)}
          >
            Cancel
          </WSButton.Tertiary>
        </WSButtons>
      </WSForm>
    </WSModal>
  );
};
